import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { del, get, post, patch } from "../../api/api";

// Listar fatores por empresa
export const listarfatores = async (empId: string) => {
  return await get<IRespostaFuncao<any[]>>(`/empresas/${empId}/fatores`);
};

// Listar Fator por Id
export const listarFator = async (fatorId: string) => {
  return await get<IRespostaFuncao<any[]>>(`/fatores/${fatorId}`);
};

// Criar Fator
export const criarFator = async (
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/fatores/cria-fator`,
    payload
  );
};

// Atualizar Fator
export const atualizarFator = async (
  fatorId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/fatores/${fatorId}/atualiza-fator`,
    payload
  );
};

// Deletar Fator
export const deletarFator = async (
  fatorId: string
): Promise<IRespostaFuncao<any>> => {
  return await del<IRespostaFuncao<any>>(
    `/fatores/${fatorId}/remove-fator`
  );
};
